import React, { useRef, useEffect } from 'react';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SectionHead } from '../../../../components/SectionHead/SectionHead';
import { FeaturedCard } from '../FeaturedCard';
import './FeaturedSection.scss';

SwiperCore.use([Navigation]);

const sliderSettings = {
  slidesPerView: 1,
  slidesPerGroup: 1,
  navigation: true,
  breakpoints: {
    480: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 10
    },
    768: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 10
    },
    1024: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      spaceBetween: 10
    },
    1400: {
      slidesPerView: 5,
      slidesPerGroup: 5,
      spaceBetween: 10
    },
    1920: {
      slidesPerView: 5,
      slidesPerGroup: 5,
      spaceBetween: 20
    }
  }
};

export function FeaturedSection({ data }) {
  const slider = useRef();

  useEffect(() => {
    const sliderEl = slider.current;
    const arrowLeftEl = sliderEl?.querySelector('.swiper-button-prev');
    const arrowRightEl = sliderEl?.querySelector('.swiper-button-next');

    arrowLeftEl?.addEventListener('click', sendPrevBtnClickToAnalytics);
    arrowRightEl?.addEventListener('click', sendNextBtnClickToAnalytics);

    return () => {
      arrowLeftEl?.removeEventListener('click', sendPrevBtnClickToAnalytics);
      arrowRightEl?.removeEventListener('click', sendNextBtnClickToAnalytics);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sendPrevBtnClickToAnalytics = () => {
    // actid=9
    window.analytics?.track("button:click", {
      "button_name": "swiper-button-prev",
      "parent_object_title": data.title,
      "url": window.location.href
    });
  }
  const sendNextBtnClickToAnalytics = () => {
    // actid=9
    window.analytics?.track("button:click", {
      "button_name": "swiper-button-next",
      "parent_object_title": data.title,
      "url": window.location.href
    });
  }

  if(!data.content?.length) {
    return null;
  }

  return (
    <div className="FeaturedSection">
      <SectionHead
        titleUppercase
        title={data.title}
      />

      <Swiper
        ref={slider}
        {...sliderSettings}
        className="FeaturedSection__slider"
      >
        {data.content.map((item, i) => (
          <SwiperSlide key={i}>
            <FeaturedCard data={item} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
